import { Icon } from "@mdi/react";
import React from "react";
import { toast } from "react-toastify";

import { mdiContentCopy } from "@mdi/js";

import { useAutomationBroker } from "components/automation/contexts/AutomationBrokerContext";
import { AutomationCommand } from "components/automation/types/automation";
import {
  ChartScreenshotPayload,
  SettingsProps
} from "components/automation/types/payloads";
import { ScreenshotSettingsResult } from "components/automation/types/results";
import { Topics } from "components/automation/types/topics";
import { ScreenshotAutomationHandler } from "components/screenshot/ScreenshotAutomationHandler";

import { StyledContainer, StyledCopyButton, StyledLabelValue } from "./shared";

export const TakeChartScreenshotSettings: React.FC<
  SettingsProps<ChartScreenshotPayload>
> = ({ value, onChange }) => {
  const broker = useAutomationBroker();
  const loadCurrentProjectAndFilter = async () => {
    const result = await broker.executeCommands([
      {
        id: "get chart screenshot",
        topic: Topics.GetChartScreenshotSettings,
        delay: 200
      } as AutomationCommand
    ]);
    if (result.length > 0 && result[0]) {
      onChange({
        ...(result[0] as ScreenshotSettingsResult)
      } as ChartScreenshotPayload);
    } else {
      toast.error("Unable to copy chart settings. Please open chart screenshot first.");
    }
  };

  return (
    <StyledContainer>
      <ScreenshotAutomationHandler />
      <StyledCopyButton
        size="large"
        onClick={loadCurrentProjectAndFilter}
        icon={<Icon path={mdiContentCopy} size={1.2} />}>
        Copy Chart Screenshot Settings
      </StyledCopyButton>
      <StyledLabelValue>
        <span className="label">Preset:</span>
        <span className="value">{value?.title ?? "No presets selected"}</span>
      </StyledLabelValue>
      <StyledLabelValue>
        <span className="label">Dimension:</span>
        <span className="value">
          {value?.width && value?.height
            ? `${value?.width} x ${value?.height}`
            : "No presets selected"}
        </span>
      </StyledLabelValue>
      <StyledLabelValue>
        <span className="label">Legend:</span>
        <span className="value">{value?.legendVisible ? "On" : "Off"}</span>
      </StyledLabelValue>
    </StyledContainer>
  );
};
